var map = {
	"./upcoming_js.png": "./src/assets/images/upcoming_courses/upcoming_js.png",
	"./upcoming_online_security.png": "./src/assets/images/upcoming_courses/upcoming_online_security.png",
	"./upcoming_python.png": "./src/assets/images/upcoming_courses/upcoming_python.png",
	"./upcoming_scratch.png": "./src/assets/images/upcoming_courses/upcoming_scratch.png",
	"./upcoming_social.png": "./src/assets/images/upcoming_courses/upcoming_social.png",
	"./upcoming_ux-ui.jpg": "./src/assets/images/upcoming_courses/upcoming_ux-ui.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/upcoming_courses sync recursive ^\\.\\/.*$";